import { Component, Input } from '@angular/core';

import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import * as uuid from 'uuid';

import { QuizzAnswer, QuizzQuestion } from '../../classes/quizz';

/**
 * @fileOverview
 * Quizz editor
 * Edits the question list of a QUIZZ mission (Mission.quizzList)
 * Each question holds its own answers, one of them being the correct one
 */

@Component({
    selector: 'app-quizz',
    templateUrl: './quizz.component.html',
    styleUrls: ['./quizz.component.scss'],
    standalone: false
})

export class QuizzComponent {

  @Input() questions: QuizzQuestion[];
  @Input() resources;
  @Input() game;
  @Input() languages;
  @Input() defaultLang;

  currentQuestion: QuizzQuestion;

  addQuestion(event){
    event.stopPropagation();
    const question: QuizzQuestion = { labels: {}, answers: [] };
    this.questions.push(question);
    this.addAnswer(question);
    this.editQuestion(question);
  }

  toggleQuestion(question: QuizzQuestion){
    if(this.currentQuestion === question){
      delete this.currentQuestion;
      return;
    }
    this.editQuestion(question);
  }

  editQuestion(question: QuizzQuestion){
    if(!question.answers){
      question.answers = [];
    }
    for(let answer of question.answers){
      //older answers may miss the fields edited below
      if(!answer.selectedResources) answer.selectedResources = {};
      if(!answer.selectedTxt) answer.selectedTxt = {};
    }
    this.currentQuestion = question;
  }

  deleteQuestion(index){
    const deleted = this.questions.splice(index, 1)[0];
    if(deleted === this.currentQuestion){
      delete this.currentQuestion;
    }
  }

  addAnswer(question: QuizzQuestion){
    if(!question.answers){
      question.answers = [];
    }
    question.answers.push({
      value: uuid.v4(),
      labels: {},
      correct: question.answers.length == 0,
      reward: 0,
      selectedResources: {},
      selectedTxt: {}
    });
  }

  deleteAnswer(question: QuizzQuestion, index){
    const deleted = question.answers.splice(index, 1)[0];
    //the question always keeps one correct answer
    if(deleted.correct && question.answers.length > 0){
      this.setCorrectAnswer(question, question.answers[0]);
    }
  }

  setCorrectAnswer(question: QuizzQuestion, answer: QuizzAnswer){
    for(let questionAnswer of question.answers){
      questionAnswer.correct = (questionAnswer === answer);
    }
  }

  getCorrectAnswer(question: QuizzQuestion){
    if(!question.answers){
      return null;
    }
    return question.answers.filter(answer => answer.correct)[0];
  }

  drop(event: CdkDragDrop<string[]>, list) {
    moveItemInArray(list, event.previousIndex, event.currentIndex);
  }
}
